import React from 'react'
import _cx from 'classnames/bind'
import { ScrollSpy, Text } from '@adc/ui-adc'
import cls from './styles.scss'
const cx = _cx.bind(cls)

const scrollSpy = (
  <ScrollSpy selector='#faqs'>
    {({ _active, scrollTo }) => (
      <Text
        as='span'
        className='u-pointer-cursor'
        color='info'
        data-elm-id='faqs_link'
        onClick={scrollTo}
        size='tiny'
      >
        See FAQs
      </Text>
    )}
  </ScrollSpy>
)

const FAQLink = () => {
  return (
    <>
      <div className={cx('sticky-header-present')}>
        {React.cloneElement(scrollSpy, { offset: 120 })}
      </div>
      <div className={cx('sticky-header-absent')}>
        {React.cloneElement(scrollSpy, { offset: 20 })}
      </div>
    </>
  )
}

export default FAQLink
